import { generateAbbreviation } from '@/app/shared/utils/generate-abbreviation';
import { generateColorFromString } from '@/app/shared/utils/generate-color-from-string';

import { input, computed, Component, ChangeDetectionStrategy } from '@angular/core';

import { AvatarSize, AvatarShape, AvatarComponent } from '@/app/shared/components/ui/avatar';

@Component({
  selector: 'app-entity-avatar',
  imports: [AvatarComponent],
  templateUrl: './entity-avatar.component.html',
  styleUrl: './entity-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityAvatarComponent<T extends { id: number }> {
  size = input<AvatarSize>('normal');

  shape = input<AvatarShape>('rounded');

  src = input<string | undefined>();

  data = input.required<any>();

  field = input.required<string | string[]>();

  avatarAlt = computed(() => {
    const fieldValue = this.field();

    if (Array.isArray(fieldValue)) {
      return fieldValue.map((key) => this.data()[key]).find((value) => value?.length) || '';
    }

    return this.data()?.[fieldValue] ?? '';
  });

  avatarLabel = computed(() => {
    return generateAbbreviation(this.avatarAlt());
  });

  avatarColor = computed(() => {
    if (!this.data()) {
      return '#f0f2f4';
    }

    return generateColorFromString(this.avatarAlt() + this.data().id);
  });
}
